import React from 'react';
import { clsx } from 'clsx';
import { Controller } from 'react-hook-form';
import { Select, SelectContent, SelectItem, SelectTrigger } from 'src/components/ui/select';
import { WORKFLOWS_TRIGGERS_TYPE } from 'src/pages/ConfigurationPage/WorkflowsTab/constants';

const excludeTriggers = ['default'];
const WORKFLOWS_TRIGGERS = Object.keys(WORKFLOWS_TRIGGERS_TYPE).filter(
  (key) => !excludeTriggers.includes(key),
);

export const WorkflowTriggersSelect = ({ control, isCustom = true }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <div className={'input-container'}>
      <Controller
        control={control}
        name="trigger_type"
        render={({ field: { value, onChange }, fieldState: { error } }) => {
          return (
            <>
              <Select
                defaultValue={value}
                open={open}
                onOpenChange={setOpen}
                onValueChange={onChange}
              >
                <SelectTrigger className="w-full bg-[#a498ff1a] border border-[#a498ff80] rounded-sm-5">
                  <div>
                    <p className={'text-sm font-medium'}>
                      <span>{WORKFLOWS_TRIGGERS_TYPE[value]}</span>
                    </p>
                  </div>
                </SelectTrigger>
                <SelectContent className={'bg-light'}>
                  {WORKFLOWS_TRIGGERS.map((trigger) => {
                    return (
                      <SelectItem
                        className={'px-4 rounded-none bg-white hover:!bg-[#a498ff1a]'}
                        key={trigger}
                        value={trigger}
                        indicatorHidden
                      >
                        <div className="flex flex-col">
                          <div className="flex gap-2 items-center">
                            <p
                              className={clsx(
                                'text-sm text-start relative',
                                trigger === value ? 'font-semibold' : 'font-medium',
                              )}
                            >
                              <span>{WORKFLOWS_TRIGGERS_TYPE[trigger]}</span>
                            </p>
                          </div>
                        </div>
                      </SelectItem>
                    );
                  })}
                </SelectContent>
              </Select>
            </>
          );
        }}
      />
    </div>
  );
};
